<template>
  <div>
    <div class="new-form-row">
      <h3 class="new-form-legend">Forma de pagamento</h3>
    </div>
    <div class="new-form-row">
      <validation-provider rules='required|oneOf:17,9,1' v-slot="{ errors }">
        <div class="new-form-group-radio">
          <!--
          <div class="new-form-radio">
            <input
              type="radio"
              data-cy="payment"
              name="payment_form_id"
              v-model="form.payment_form_id"
              value="11"
              id="payment-1"
            >
            <label for="payment-1">Débito automático</label>
          </div>
          -->
          <div class="new-form-radio">
            <input
              type="radio"
              data-cy="payment"
              name="payment_form_id"
              v-model="form.payment_form_id"
              value="9"
              id="payment-2"
            >
            <label for="payment-2">Cartão de crédito</label>
          </div>

          <div class="new-form-radio">
            <input
              type="radio"
              data-cy="payment"
              name="payment_form_id"
              v-model="form.payment_form_id"
              value="1"
              id="payment-3"
            >
            <label for="payment-3">Boleto</label>
          </div>

          <div class="new-form-radio">
            <input
              type="radio"
              data-cy="payment"
              name="payment_form_id"
              v-model="form.payment_form_id"
              value="17"
              id="payment-4"
            >
            <label for="payment-4">Transferência bancária ou pix</label>
          </div>
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div class="new-form-row">
      <BoletoPaymentForm ref='boletoPaymentForm' :formData="this.paymentsForms.boleto"  v-if="this.form.payment_form_id === '1'" />
      <CreditPaymentForm ref='creditPaymentForm' :formData="this.paymentsForms.credit"  v-if="this.form.payment_form_id === '9'" />
      <!--<DebitPaymentForm ref='debitPaymentForm'  :formData="this.paymentsForms.debit"    v-if="this.form.payment_form_id === '11'" />-->
      <PixPaymentForm ref='pixPaymentForm'  v-if="this.form.payment_form_id === '17'" />
    </div>
  </div>
</template>

<script>

import BoletoPaymentForm from './BoletoPaymentForm';
import CreditPaymentForm from './CreditPaymentForm';
import PixPaymentForm from './PixPaymentForm';

export default {
  name: 'PaymentForm',
  components: { BoletoPaymentForm, CreditPaymentForm, PixPaymentForm },
  props: {
    paymentsForms: {
      debit: {
        bank: String,
        agency: String,
        bank_account: String,
        payment_day: Number
      },
      credit: {
        card_number: String,
        titular_name: String,
        card_month: Number,
        card_year: Number
      },
      boleto: {
        city: String,
        state: String
      }
    }
  },
  data: function () {
    return {
      form: {
        payment_form_id: ''
      }
    };
  },
  watch: {
    'form.payment_form_id' (newValue) {
      if (newValue === '17') {
        this.$parent.shouldShowNextButton(false);
      } else {
        this.$parent.shouldShowNextButton(true);
      }
    }
  },
  methods: {
    getCurrentForm: function () {
      if (this.form.payment_form_id === '1') return this.$refs.boletoPaymentForm;
      if (this.form.payment_form_id === '9') return this.$refs.creditPaymentForm;
      // if (this.form.payment_form_id === '11') return this.$refs.debitPaymentForm;
      if (this.form.payment_form_id === '17') return this.$refs.pixPaymentForm;
    },
    validForm: async function () {
      return this.getCurrentForm().validForm();
    },
    getValidationObserver: function () {
      return this.getCurrentForm().getValidationObserver();
    },
  }
};
</script>
